import { render, staticRenderFns } from "./NormalSearchNav204.vue?vue&type=template&id=08535359&scoped=true&"
import script from "./NormalSearchNav204.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav204.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08535359",
  null
  
)

export default component.exports